import { Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { EditClientModalComponent } from './edit-client-modal/edit-client-modal.component';
import { ClientManageListComponent } from './client-manage-list/client-manage-list.component';

@Component({
  selector: 'app-client-manager',
  templateUrl: './client-manager.component.html',
  styleUrls: ['./client-manager.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ClientManagerComponent {

  @ViewChild(EditClientModalComponent) editClientModal!: EditClientModalComponent;
  @ViewChild(ClientManageListComponent) clientManageList!: ClientManageListComponent;

  // Handle client updated event
  onClientUpdated(): void {
    console.log('Client updated successfully!');
    // Refresh the client listing
    if (this.clientManageList) {
      this.clientManageList.loadClients();
    }
  }

  // Open add client modal
  openAddClientModal(): void {
    console.log('Opening add client modal');
    if (this.editClientModal) {
      this.editClientModal.openAddModal();
    }
  }

}
